<div class="main-view space-y-2 md:space-y-4">
  <app-page-surface-header titleIcon="globe"
    title="Country Packs"
    subtitle="Country configuration master. Adding a pack here is the first step of onboarding a country — followed by compliance locks, a rule package, and document types."
  />

  <app-entity-catalog
    [catalog]="catalog"
    [records]="records"
    [loading]="loading"
    [saving]="saving"
    [error]="error"
    [hideTitle]="true"
    [canCreate]="view === 'active'"
    [canEdit]="view === 'active'"
    [canDelete]="view === 'active'"
    [canRestore]="view === 'deleted'"
    [toolbarTabs]="toolbarTabs"
    [activeToolbarTab]="activeToolbarTab"
    (toolbarTabChange)="onToolbarTabChange($event)"
    (save)="onSave($event)"
    (delete)="onDelete($event)"
    (restore)="onRestore($event)"
  />
</div>

<app-delete-confirm-modal
  [open]="showDeleteModal"
  heading="Delete country pack?"
  [entityName]="deleteEntityName"
  entityNoun="country pack"
  message="This will remove the country pack from the list. Packs assigned to tenants cannot be deleted."
  confirmLabel="Delete"
  loadingLabel="Deleting…"
  [loading]="deleteLoading()"
  [error]="deleteError"
  variant="permanent"
  (cancelled)="closeDeleteModal()"
  (confirmed)="submitDelete()"
/>

<app-restore-confirm-modal
  [open]="showRestoreModal"
  heading="Restore country pack?"
  [entityName]="restoreEntityName"
  activeListLabel="country packs list"
  [loading]="restoreLoading()"
  (cancelled)="closeRestoreModal()"
  (confirmed)="submitRestore()"
/>
